module.exports = __webpack_public_path__ + "img/code.22e8444f.png";